import script from "./PageHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageHeader.vue?vue&type=script&lang=ts&setup=true"

import "./PageHeader.vue?vue&type=style&index=0&id=2e38bb78&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e38bb78"]])

export default __exports__